import { GqlClient } from "@/services/graph-ql/configs";

/** @name: @getServerSideData
 *  @params: options => this could be array of object or object of query information
 *                      which include query to be fetched, query name and params
 *                      required in query
 *  @description: check options type and operate accordingly
 */
const getServerSideData = async (payload) => {
  const { request, context } = payload;
  try {
    if (Array.isArray(request)) {
      const combineData = await iterateQueries(request, context);
      return combineData;
    } else if (!Array.isArray(request) && typeof request === "object") {
      const data = await getFromGQL(request, context);
      return data;
    }
  } catch (error) {
    console.error(
      "The query parameter should be an array of object or a single object",
      error
    );
    return error;
  }
};
/** @name: @iterateQueries
 *  @params: options => this could be array of objects, object are queries
 *  @description: iterate over the options and fetch from gql
 */
const iterateQueries = async (options, context) => {
  let combineData = {};
  for await (const option of options) {
    const data = await getFromGQL(option, context);
    combineData[option?.key] = data;
  }
  return combineData;
};
/** @name: @getFromGQL
 *  @params: query: gql query,key: nested object key of the fetched data, variable: query parameters
 *  @description: fetch data from gql
 */
const getFromGQL = async (options, context) => {
  const { query, key, subKey = "", params } = options;
  const cookies = context?.req?.cookies;

  try {
    const response = await GqlClient.query({
      query,
      variables: params,
      fetchPolicy: "no-cache",
      context: {
        headers: {
          authorization: cookies?.Auth,
          companyKey: cookies?.companyKey,
        },
      },
    });
    return key
      ? subKey
        ? response?.data?.[key][subKey]
        : response?.data?.[key]
      : response?.data;
  } catch (error) {
    console.error("GQL Error::", error, key);
    return [];
  }
};

export default getServerSideData;
